import type { BooleanFeatureFlagResolution } from '../../services/featureFlags/getFeatureFlagBooleanDetails';

export type SalesOrdersNavChoice = 'pending' | 'sales' | 'orders';

/**
 * Hide both Sales and Orders until the org-keyed provider is ready. Once
 * resolved: on / FLAG_NOT_FOUND → Sales, off → Orders. flipdish-global always
 * shows Sales (cross-org view).
 */
export const getSalesOrdersNavChoice = (
  appId: string | undefined | null,
  resolution: BooleanFeatureFlagResolution
): SalesOrdersNavChoice => {
  if (appId === 'flipdish-global') {
    return 'sales';
  }
  if (resolution.status === 'pending') {
    return 'pending';
  }
  return resolution.value ? 'sales' : 'orders';
};
